import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login.jsx";
import Register from "./components/Register.jsx";
import Dashboard from "./components/Dashboard.jsx";
import Forgot from "./components/Forgot.jsx";
import Changepass from "./components/Changepass.jsx";
import PNF from "./components/PNF.jsx";
import "./styles/index.scss";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/update/:uid/:token" element={<Changepass />} />
        <Route path="*" element={<PNF />} />
      </Routes>
    </Router>
  );
}

export default App;
